export function isValidatorFn(rule) {
    return typeof rule === 'function';
}
export function isValidatorRegExp(rule) {
    return rule instanceof RegExp;
}
export function isRuleValueForFunction(ruleValue) {
    return typeof ruleValue === 'string' || !isNaN(+ruleValue);
}
